<app-modal-header title="Built-in integrations" (onClose)="dialogRef.close()"></app-modal-header>

<mat-dialog-content>
  <div class="text-gray-400 text-sm">
    <p class="mb-3">
      Onion offers pay-as-you-go access to certain third-party services, like data enrichment and email validation.
    </p>
    <p class="mb-3">
      To ensure smooth usage and cost management, this feature is only available for workspaces with an active subscription. Free tiers, lifetime access or long term coupons are not included.
    </p>
    <p>
      If you have your own API key, you can still use these services without any restrictions by creating an integration.
    </p>
    <hr class="my-3">
    <p class="mb-3">
      If you want to enable pay-as-you-go for your workspace you have 2 options:
    </p>
    <div class="flex justify-center">
      <a class="btn btn-primary btn-sm mx-1" [routerLink]="['./workspace', workspaceSvc.workspaceId, 'overview', 'billing']" target="_blank" title="Upgrade workspace">
        Upgrade workspace
      </a>
      <button class="btn btn-primary btn-outline btn-sm mx-1" (click)="commonModalSvc.getInTouch()">
        Contact us
      </button>
    </div>

  </div>


</mat-dialog-content>
